var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 44.4285C46 43.7973 46.4477 43.2856 47 43.2856H80C80.5523 43.2856 81 43.7973 81 44.4285V79.8571C81 80.4883 80.5523 80.9999 80 80.9999C79.4477 80.9999 79 80.4883 79 79.8571V45.5714H48V79.8571C48 80.4883 47.5523 80.9999 47 80.9999C46.4477 80.9999 46 80.4883 46 79.8571V44.4285Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3356 23.003C63.7484 22.5837 64.3805 22.6262 64.7474 23.098L80.7474 43.6694C81.1143 44.1411 81.0772 44.8635 80.6644 45.2828C80.2516 45.7022 79.6195 45.6597 79.2526 45.1879L63.2526 24.6165C62.8857 24.1447 62.9229 23.4224 63.3356 23.003Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6866 23.0263C64.2851 22.593 63.6522 22.6136 63.273 23.0725L46.273 43.6439C45.8938 44.1028 45.9119 44.8261 46.3134 45.2595C46.7149 45.6929 47.3478 45.6722 47.727 45.2134L64.727 24.6419C65.1062 24.1831 65.0881 23.4597 64.6866 23.0263Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.14286C11 1.51167 11.4477 1 12 1H39C39.295 1 39.5749 1.14884 39.7649 1.40672L47.7649 12.2642C47.9167 12.4702 48 12.731 48 13.0003V45.0003C48 45.6315 47.5523 46.1432 47 46.1432C46.4477 46.1432 46 45.6315 46 45.0003V13.4174L38.5347 3.28571H13V22.7146C13 23.3458 12.5523 23.8575 12 23.8575C11.4477 23.8575 11 23.3458 11 22.7146V2.14286Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 23.8572C1 23.226 1.44772 22.7144 2 22.7144H26C26.5523 22.7144 27 23.226 27 23.8572V79.8572C27 80.4884 26.5523 81.0001 26 81.0001C25.4477 81.0001 25 80.4884 25 79.8572V25.0001H2C1.44772 25.0001 1 24.4884 1 23.8572Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 22.7144C2.55228 22.7144 3 23.226 3 23.8572V79.8572C3 80.4884 2.55228 81.0001 2 81.0001C1.44772 81.0001 1 80.4884 1 79.8572V23.8572C1 23.226 1.44772 22.7144 2 22.7144Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 29.5715C7.55228 29.5715 8 30.0832 8 30.7144V79.8573C8 80.4884 7.55228 81.0001 7 81.0001C6.44772 81.0001 6 80.4884 6 79.8573V30.7144C6 30.0832 6.44772 29.5715 7 29.5715Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 29.5715C12.5523 29.5715 13 30.0832 13 30.7144V79.8573C13 80.4884 12.5523 81.0001 12 81.0001C11.4477 81.0001 11 80.4884 11 79.8573V30.7144C11 30.0832 11.4477 29.5715 12 29.5715Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 43.2856C75.5523 43.2856 76 43.7973 76 44.4285V79.8571C76 80.4883 75.5523 80.9999 75 80.9999C74.4477 80.9999 74 80.4883 74 79.8571V44.4285C74 43.7973 74.4477 43.2856 75 43.2856Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 50.1429C30 49.5117 30.4477 49 31 49H34C34.5523 49 35 49.5117 35 50.1429C35 50.774 34.5523 51.2857 34 51.2857H31C30.4477 51.2857 30 50.774 30 50.1429Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 50.1429C37 49.5117 37.4477 49 38 49H41C41.5523 49 42 49.5117 42 50.1429C42 50.774 41.5523 51.2857 41 51.2857H38C37.4477 51.2857 37 50.774 37 50.1429Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 44.4285C30 43.7973 30.4477 43.2856 31 43.2856H34C34.5523 43.2856 35 43.7973 35 44.4285C35 45.0597 34.5523 45.5714 34 45.5714H31C30.4477 45.5714 30 45.0597 30 44.4285Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 44.4285C37 43.7973 37.4477 43.2856 38 43.2856H41C41.5523 43.2856 42 43.7973 42 44.4285C42 45.0597 41.5523 45.5714 41 45.5714H38C37.4477 45.5714 37 45.0597 37 44.4285Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 38.7144C30 38.0832 30.4477 37.5715 31 37.5715H34C34.5523 37.5715 35 38.0832 35 38.7144C35 39.3456 34.5523 39.8572 34 39.8572H31C30.4477 39.8572 30 39.3456 30 38.7144Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 38.7144C37 38.0832 37.4477 37.5715 38 37.5715H41C41.5523 37.5715 42 38.0832 42 38.7144C42 39.3456 41.5523 39.8572 41 39.8572H38C37.4477 39.8572 37 39.3456 37 38.7144Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 29.5713C30 28.9401 30.4477 28.4285 31 28.4285H34C34.5523 28.4285 35 28.9401 35 29.5713C35 30.2025 34.5523 30.7142 34 30.7142H31C30.4477 30.7142 30 30.2025 30 29.5713Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 29.5713C37 28.9401 37.4477 28.4285 38 28.4285H41C41.5523 28.4285 42 28.9401 42 29.5713C42 30.2025 41.5523 30.7142 41 30.7142H38C37.4477 30.7142 37 30.2025 37 29.5713Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 23.8572C30 23.226 30.4477 22.7144 31 22.7144H34C34.5523 22.7144 35 23.226 35 23.8572C35 24.4884 34.5523 25.0001 34 25.0001H31C30.4477 25.0001 30 24.4884 30 23.8572Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 23.8572C37 23.226 37.4477 22.7144 38 22.7144H41C41.5523 22.7144 42 23.226 42 23.8572C42 24.4884 41.5523 25.0001 41 25.0001H38C37.4477 25.0001 37 24.4884 37 23.8572Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 18.1429C30 17.5117 30.4477 17 31 17H34C34.5523 17 35 17.5117 35 18.1429C35 18.774 34.5523 19.2857 34 19.2857H31C30.4477 19.2857 30 18.774 30 18.1429Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 18.1429C37 17.5117 37.4477 17 38 17H41C41.5523 17 42 17.5117 42 18.1429C42 18.774 41.5523 19.2857 41 19.2857H38C37.4477 19.2857 37 18.774 37 18.1429Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 79.8572C1 79.226 1.44772 78.7144 2 78.7144H80C80.5523 78.7144 81 79.226 81 79.8572C81 80.4884 80.5523 81.0001 80 81.0001H2C1.44772 81.0001 1 80.4884 1 79.8572Z",
    fill: "#E59E6D",
    stroke: "#E59E6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.b58307e93006f546e6fa7b813c5bcd7a.svg";
export { ForwardRef as ReactComponent };